import React from 'react'
import Head from 'next/head'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Layout from '../../src/components/General/Layout'
import Privacy from '../../src/components/Sections/Privacy'

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
    },
}))

const PrivacyPage = () => {
    const classes = useStyles()
    return (
        <Layout>
            <Head>
                <title>
                    Privacy Policy | Mase Rasti Team - Your trusted realtor!
                </title>
                <meta
                    name="description"
                    content="Privacy Policy - Mase Rasti Team Real Estate"
                />
            </Head>
            <Container className={classes.container}>
                <Privacy />
            </Container>
        </Layout>
    )
}

export default PrivacyPage
